import React, { useState, FC } from 'react';
import CsvDownloader, { ICsvDownloadProps } from 'react-csv-downloader';
import { getResolveData } from '@utils/csv';
import { Spin } from 'antd';

type CsvProps = Pick<ICsvDownloadProps, 'columns' | 'filename'>;
interface IProps extends CsvProps {
  getData: () => Promise<any[]>;
  skipFields?: string[];
  label?: string;
}

const DownloadCsv: FC<IProps> = props => {
  const {
    filename = 'progkids.csv',
    getData,
    skipFields,
    columns,
    label = 'CSV',
  } = props;
  const [isLoading, setIsLoading] = useState(false);

  const resolveData = async () => {
    setIsLoading(true);
    let result;
    try {
      result = await getData();
    } catch (error) {
      result = [];
    }

    setIsLoading(false);
    return getResolveData(result, skipFields);
  };

  return (
    <CsvDownloader
      columns={columns}
      className="btn btn-green-small"
      datas={resolveData}
      filename={filename}
    >
      {isLoading ? <Spin spinning /> : label}
    </CsvDownloader>
  );
};

export default DownloadCsv;
